import { atom } from "recoil";

export const RootLoadingState = {
  isLoading: atom({
    key: "IsLoading",
    default: false,
  }),
};
